import * as Contentful from 'contentful'

import { TypeSectionFields } from './section'
import { TypeItemTab } from './item-tab'
import { TypeItemFeatureHighlight } from './item-feature-highlight'

export enum ColorStyleType {
  Default = 'Default',
  Black = 'Black',
}

export interface TypeSectionTabsFields extends TypeSectionFields {
  heading: TypeItemFeatureHighlight
  itemTab: TypeItemTab[]
  colorStyle?: ColorStyleType
}

export type TypeSectionVerticalTabs = Contentful.Entry<TypeSectionTabsFields>
